import React, { createContext, useReducer, useContext } from 'react';
import { useUserContext } from './UserContext';

const PriceContext = createContext({});
const initialState = {
  price: [],
  loading: false,
  hostname: process.env.REACT_APP_API_URL || '',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'GET_PRICE':
      return { ...state, price: action.payload, loading: false };
    case 'ADD_PRICE':
      return { ...state, price: [...state.price, action.payload] };
    case 'UPDATE_PRICE':
       return {
            ...state,
            price: state.price.map(p =>
            p._id === action.payload._id ? { ...p, ...action.payload } : p
            ),
        };
    case 'DELETE_PRICE':
      return { ...state, price: state.price.filter(p => p._id !== action.payload) };
    default:
      return state;
  }
};

export const PriceProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { logout } = useUserContext();

  const authHeaders = () => ({
    'Content-Type': 'application/json',
    'x-access-token': JSON.parse(localStorage.getItem('authToken') || '{}').token,
  });

  const checkAuth = (data) => {
    if (data?.isLoggetIn === false) logout();
  };

  const fetchPrice = async () => {
    dispatch({ type: 'SET_LOADING', payload: true });
    try {
      const res = await fetch(`${initialState.hostname}/price/getprice`, { headers: authHeaders() });
      const data = await res.json();
      checkAuth(data);
      dispatch({ type: 'GET_PRICE', payload: data.data || [] });
    } catch (e) {
      console.error(e);
      dispatch({ type: 'SET_LOADING', payload: false });
    }
  };

  const importPriceBatch = async (items) => {
    const res = await fetch(`${initialState.hostname}/price/import`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ items }),
    });
    const data = await res.json();
    checkAuth(data);
    debugger
    if (!res.ok) throw new Error(data.message || 'Ошибка импорта');

    // Обновляем локальный стейт после импорта
    if (Array.isArray(data.data.createdItems) && data.data.createdItems.length) {
        data.data.createdItems.forEach(item => dispatch({ type: 'ADD_PRICE', payload: item }));
    }
    return {
        created: data.data.created || 0,
        skipped: data.data.skipped || 0,
        errors: data.data.errors || 0,
        errorSamples: data.data.errorSamples || [],
    };
    };

  const addPrice = async (body) => {
    const res = await fetch(`${initialState.hostname}/price/create`, {
      method: 'POST', headers: authHeaders(), body: JSON.stringify(body),
    });
    const data = await res.json();
    checkAuth(data);
    if (data.data._id) {
      dispatch({ type: 'ADD_PRICE', payload: { ...body, _id: data.data._id } });
      return data;
    }
    throw new Error(data.message || 'Не удалось создать');
  };

  const updatePrice = async (id, body) => {
    const res = await fetch(`${initialState.hostname}/price/update/${id}`, {
      method: 'PUT', headers: authHeaders(), body: JSON.stringify(body),
    });
    const data = await res.json();
    checkAuth(data);
    debugger
    if (res.ok) {
      dispatch({ type: 'UPDATE_PRICE', payload: { ...body, _id: id } });
      return data;
    }
    throw new Error(data.message || 'Не удалось сохранить');
  };

  const deletePrice = async (id) => {
    const res = await fetch(`${initialState.hostname}/price/delete/${id}`, {
      method: 'DELETE', headers: authHeaders(),
    });
    const data = await res.json();
    checkAuth(data);
    if (res.ok) dispatch({ type: 'DELETE_PRICE', payload: id });
    return data;
  };

  return (
    <PriceContext.Provider value={{ ...state, fetchPrice, addPrice, updatePrice, deletePrice, importPriceBatch }}>
      {children}
    </PriceContext.Provider>
  );
};

export const usePriceContext = () => useContext(PriceContext);